import { useState } from "react";
import api from "../../lib/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { ArtworkUploadForm } from "./ArtworkUploadForm";

/** Center uploads an artwork on behalf of an artist the center created. */
export const CenterUploadArtworkPanel = ({ members = [], onUploaded }) => {
  const [artistId, setArtistId] = useState("");
  const ownArtists = members.filter((m) => m.created_by_center);
  const selected = ownArtists.find((m) => m.artist_id === artistId);

  return (
    <div data-testid="center-upload-panel">
      <div className="border border-[#E5E0D8] bg-white p-6">
        <p className="label-eyebrow text-[#1E3A8A]">— Upload a work on behalf of an artist</p>
        <p className="text-sm text-[#555] mt-2 max-w-2xl">
          Only available for artists your hub created. The work is listed under the
          artist's name and presented by your hub; it goes live after admin review.
        </p>
        {ownArtists.length === 0 ? (
          <p data-testid="center-upload-no-artists" className="mt-4 text-sm text-[#555]">
            You haven't created any artists yet — add one in the Artists tab first.
          </p>
        ) : (
          <div className="mt-4 max-w-sm">
            <label className="label-eyebrow text-[#555]">Artist</label>
            <Select value={artistId} onValueChange={setArtistId}>
              <SelectTrigger
                data-testid="center-upload-artist-select"
                className="mt-2 rounded-none border-b-2 border-l-0 border-r-0 border-t-0 border-[#E5E0D8] bg-transparent px-0 focus:ring-0"
              >
                <SelectValue placeholder="Choose an artist…" />
              </SelectTrigger>
              <SelectContent className="rounded-none">
                {ownArtists.map((m) => (
                  <SelectItem key={m.artist_id} value={m.artist_id}>
                    {m.artist_name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </div>

      {selected && (
        <ArtworkUploadForm
          key={artistId}
          user={selected.artist}
          submitFn={(payload) => api.post("/center/artworks", { ...payload, artist_id: artistId })}
          onCreated={(art) => onUploaded?.(art)}
        />
      )}
    </div>
  );
};
